
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.137","height":"12.493"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.822 4.41C3.174 3.65 3.5 2.868 3.935 2c.239-.413.5-.782.978-.826h7.322c.478.043.739.413.978.826.435.869.76 1.651 1.108 2.412zm3.437 3.129h4.606a.511.511 0 010 1.021H6.259a.511.511 0 010-1.021zM4.912 0C4.13 0 3.652.282 3 1.195L1.914 3.65H.263c-.261 0-.741 1.35.999 1.391L.676 6.453c.022 1.8.022 3.585.022 5.366a.677.677 0 00.674.674h2.26a.659.659 0 00.652-.674v-1.477h8.56v1.477a.677.677 0 00.674.674h2.26a.659.659 0 00.652-.674c0-1.782.022-3.563.022-5.366l-.587-1.412C17.622 5 17.122 3.65 16.884 3.65h-1.651l-1.087-2.455C13.494.282 13.016 0 12.234 0zm9.082 6.583a1.089 1.089 0 00-1.086 1.086 1.1 1.1 0 001.086 1.086 1.089 1.089 0 001.086-1.086 1.076 1.076 0 00-1.086-1.086zm-10.842 0a1.089 1.089 0 011.087 1.086 1.1 1.1 0 01-1.086 1.087 1.089 1.089 0 01-1.087-1.087 1.076 1.076 0 011.087-1.086z","fill":"#9a9a9a","fill-rule":"evenodd"}})])
          )
        }
      }
    